import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material/dialog';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { sentry } from 'sentry';
import { LocationsGroupsService } from './../services/locations-groups-resolver.service';
var DialogLocationsGroupsComponent = /** @class */ (function () {
    function DialogLocationsGroupsComponent(data, matDialogRef, locationsGroupsService, customMessageService, progressBar) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.locationsGroupsService = locationsGroupsService;
        this.customMessageService = customMessageService;
        this.progressBar = progressBar;
        this.isInvalidForm = true;
        this.isSaving = false;
        this.locationGroup = this.data.locationGroup;
        this.isViewMode = this.data.isViewMode;
    }
    DialogLocationsGroupsComponent.prototype.getForm = function (form) {
        this.locationGroupForm = form;
        this.isInvalidForm = this.locationGroupForm.invalid;
    };
    DialogLocationsGroupsComponent.prototype.onArchivedClick = function (archived) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveLocationGroup(tslib_1.__assign({}, this.locationGroupForm.value, { archived: archived }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationsGroupsComponent.prototype.onSaveClick = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveLocationGroup(this.locationGroupForm.value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationsGroupsComponent.prototype.saveLocationGroup = function (locationsGroupsInput) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.progressBar.show();
                        this.isSaving = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.locationsGroupsService.save(this.locationGroup.id, locationsGroupsInput)];
                    case 2:
                        _a.sent();
                        if (locationsGroupsInput.archived) {
                            this.locationGroup.archived = locationsGroupsInput.archived;
                        }
                        this.customMessageService.success('LOCATIONS_GROUPS.SUCCESS_MESSAGE');
                        this.matDialogRef.close({ reload: true });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        code = getErrorCode(err_1);
                        if (code === 'location_group_name_duplicated') {
                            this.locationGroupForm.get('name').setErrors({
                                'location_group_name_duplicated': true
                            });
                            return [2 /*return*/];
                        }
                        this.customMessageService.error('LOCATIONS_GROUPS.ERROR_MESSAGE');
                        sentry.captureException(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.progressBar.hide();
                        this.isSaving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return DialogLocationsGroupsComponent;
}());
export { DialogLocationsGroupsComponent };
